<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success2">
      <!-- Card stats -->
    </base-header>
    <b-container fluid class="mt--7">
      <b-row>
        <b-col>
          <minasidor-table />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Table,
  TableColumn
} from "element-ui";
import projects from "./Tables/projects";
import users from "./Tables/users";
import LightTable from "./Tables/RegularTables/LightTable";
import MinasidorTable from "./Tables/RegularTables/MinaSidorTable";
import Vue from "vue";
import VueCookies from "vue-cookies";
import axios from "axios";
import VueAxios from "vue-axios";

//Vue.$cookies.config("30d");

export default {
  components: {
    LightTable,
    MinasidorTable,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {
      projects,
      users
    };
  }
};
</script>
<style>
.bg-gradient-success2 {
  background: linear-gradient(87deg, #2d70ceb0 0, #2d32ce 100%) !important;
}
.el-table.table-dark {
  background-color: #172b4d;
  color: #f8f9fe;
}

.el-table.table-dark th,
.el-table.table-dark tr {
  background-color: #172b4d;
}

.el-table.table-dark td,
.el-table.table-dark th.is-leaf {
  border-bottom: none;
}
</style>
